<template>
  <ion-app>
    <loading-bar></loading-bar>
    <ion-router-outlet />
  </ion-app>
</template>

<script>
import { IonApp, IonRouterOutlet, IonHeader, IonContent } from "@ionic/vue";
import { defineComponent } from "vue";
import { SplashScreen } from "@capacitor/splash-screen";
import { GoogleAuth } from "@codetrix-studio/capacitor-google-auth";
import { Capacitor } from "@capacitor/core";
import { FacebookLogin } from "@capacitor-community/facebook-login";
import loadingBar from "./views/loadingbar.vue";
import { provide } from "vue";
import { PushNotifications } from "@capacitor/push-notifications";
import firebaseMessaging from "./firebase";
export default defineComponent({
  name: "App",
  components: {
    IonApp,
    IonRouterOutlet,
    IonHeader,
    IonContent,
    "loading-bar": loadingBar,
  },
  provide: {
    messaging: firebaseMessaging,
  },
  created() {
    if (this.$store.state.authuser && this.$store.state.authuser.id) {
      this.$store.dispatch("accountDetails", {
        id: this.$store.state.authuser.id,
      });
    }
    if (this.$store.state.authuser) {
      this.$store.dispatch("stories");
      this.$store.dispatch("unreadNotifications");
      this.$store.dispatch("chatList");
      this.$store.dispatch("feeds");
      this.$store.dispatch("friendSuggestions");
      this.$store.dispatch("userCurrentLocation");
    }
  },
  data() {
    return {};
  },
  methods: {
    async addListeners() {
      await PushNotifications.addListener("registration", (token) => {
        console.info("Registration token: ", token.value);
        axios
          .post(
            `${this.$store.state.endpoints.registerNotifTokenURL}`,
            { registration_id: token.value, type: "android" },
            {
              headers: { Authorization: `Bearer ${this.$store.state.jwt}` },
            }
          )
          .then((response) => {
            console.log(response.data);
          });
      });

      await PushNotifications.addListener("registrationError", (err) => {
        console.error("Registration error: ", err.error);
      });

      await PushNotifications.addListener(
        "pushNotificationReceived",
        (notification) => {
          console.log("Push notification received: ", notification);
        }
      );

      await PushNotifications.addListener(
        "pushNotificationActionPerformed",
        (notification) => {
          console.log(
            "Push notification action performed",
            notification.actionId,
            notification.inputValue
          );
        }
      );
    },
    async registerNotifications() {
      let permStatus = await PushNotifications.checkPermissions();

      if (permStatus.receive === "prompt") {
        permStatus = await PushNotifications.requestPermissions();
      }

      if (permStatus.receive !== "granted") {
        throw new Error("User denied permissions!");
      }

      await PushNotifications.register();
    },
    async getDeliveredNotifications() {
      const notificationList =
        await PushNotifications.getDeliveredNotifications();
      console.log("delivered notifications", notificationList);
    },
  },
  beforeCreate() {},
  beforeMount() {
    let externaLink = document.createElement("link");
    externaLink.setAttribute(
      "href",
      "https://stackpath.bootstrapcdn.com/font-awesome/4.7.0/css/font-awesome.min.css"
    );
    externaLink.setAttribute("rel", "stylesheet");
    document.head.appendChild(externaLink);
  },
  mounted() {
    this.addListeners();
    this.registerNotifications();
    this.getDeliveredNotifications();
    setTimeout(() => {
      SplashScreen.hide({
        // fadeOutDuration: 250,
      });
    }, 1000); // this could range from 0 to probably no more than 2000, just experiment a little
    console.log("USER", this.$store.state.authuser);
    // this.$store.dispatch("accountDetails");
    if (
      Capacitor.getPlatform() === "ios" ||
      Capacitor.getPlatform() === "android"
    ) {
      GoogleAuth.initialize();
    } else {
      GoogleAuth.initialize({
        clientId:
          "1037447160346-9vq0791rtpjva30lv15ntokfep10h6cs.apps.googleusercontent.com",
        scopes: ["profile", "email"],
        grantOfflineAccess: true,
      });

      FacebookLogin.initialize({ appId: "3696703733725129" });
    }
  },
});
</script>

<style scoped>
.logo img {
  width: 150px;
  height: 48px;
  object-fit: cover;
}
</style>
